export default {
  FETCHED_ALL: 'FETCHED_ALL_MARKET_SPACES',
  FETCHED_MULTIPLE: 'FETCHED_MARKET_SPACES',
  FETCHED_SINGLE: 'FETCHED_MARKET_SPACE',
  DELETED_SINGLE: 'DELETED_MARKET_SPACE',
  FETCHED_LEADERBOARD: 'FETCHED_LEADERBOARD',
};
